export enum ChartColors {
  ORDERS = "#228BE6",
  CANCELED_ORDERS = "#175C99",
  INVOICES = "#7EDCFA",
  CANCELED_INVOICES = "#0099C9",
  CREDIT_NOTES = "#D22C5E",
  QUOTA = "#868e96",
}
